require('./RALastMovement.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const Immutable = require('immutable');
const classnames = require('classnames');
const moment = require('moment');

// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');

// @utilities
const emptyIcon = require('../../assets/icons/empty_movimientos_empty.svg');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { classifyItemsByDate } = require('utilities/tableMovementsHelper.js');
const { toCamelCase, getLastNChars } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
const { recordLink } = require('utilities/tagging');

// @components
const RALastMovementFilter = require('./RALastMovementFilter/RALastMovementFilter');
const RAOneLineSymbolAmount = require('../commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');

// @constants
const {
    LAST_MOVEMENTS_TABLE_RECENT_ITEMS,
    RA_MOVEMENTS_FILTER_ALL,
    STATUS_PENDING,
    PROC_RA_LAST_MOVEMENTS,
    PROC_RA_LAST_MOVEMENTS_FILTER,
    PROC_RA_LAST_MOVEMENTS_SHOW_MORE,
} = require('../../raConstants/index');

const { DATE_FORMAT_DAY_MONTH_SHORT } = require('constants/index');

class RALastMovement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filterIsOpen: false,
            emptyState: false,
            rowsNumber: 8,
            portfolioModalValue: props.profileObject['name'],
            typeModalValue: props.filter.get('typeModalValue'),
            profileId:
                props.profileObject['portfolioIds'] &&
                props.profileObject['portfolioIds'][0],
        };

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleMoreMovements = this.handleMoreMovements.bind(this);
        this.handleCloseFilter = this.handleCloseFilter.bind(this);
        this.handleTypeModalChange = this.handleTypeModalChange.bind(this);
    }

    componentDidMount() {
        const {
            immLastMovement,
            profileObject,
            requestLastMovement,
        } = this.props;
        const isActive = immLastMovement.getIn([
            'lastMovementsRow',
            'filter',
            'date',
            'isActive',
        ]);
        if (
            profileObject &&
            profileObject.portfolioIds &&
            profileObject.portfolioIds[0]
        ) {
            requestLastMovement(profileObject.portfolioIds[0], isActive);
        } else {
            requestLastMovement('', isActive);
        }
    }

    handleCloseFilter(type) {
        const {
            changeLastMovementFilter,
            immLastMovement,
            requestLastMovement,
        } = this.props;
        const profileId = immLastMovement.getIn([
            'lastMovementsRow',
            'filter',
            'profileId',
        ]);
        const isActive = immLastMovement.getIn([
            'lastMovementsRow',
            'filter',
            'date',
            'isActive',
        ]);
        const typeValue =
            type == 'DateValue' || (type == 'typeModalValue' && !isActive);

        if (type == 'typeModalValue') {
            this.setState({
                typeModalValue: RA_MOVEMENTS_FILTER_ALL,
            });
        }
        changeLastMovementFilter(type, RA_MOVEMENTS_FILTER_ALL);
        requestLastMovement(profileId, !typeValue);
    }

    handleToggleModal() {
        recordLink(PROC_RA_LAST_MOVEMENTS, PROC_RA_LAST_MOVEMENTS_FILTER);
        this.setState({
            filterIsOpen: !this.state.filterIsOpen,
        });
    }

    buildTableHeader(isEmpty, fullView) {
        const headerClass = classnames({
            'ra-last-movement__header-empty': isEmpty,
            'ra-last-movement__header-row': !isEmpty && !fullView,
            'ra-last-movement__header-full': fullView,
        });
        return (
            <thead>
                <OKTableRow className={headerClass}>
                    <OKTableCell
                        className={'ra-last-movement__header-row-date'}
                        asHeader={true}
                    >
                        <FormattedText
                            value="raLastMovement-bookingDate"
                            format="uppercase"
                        />
                    </OKTableCell>
                    <OKTableCell
                        className={'ra-last-movement__header-row-type'}
                        asHeader={true}
                    >
                        <FormattedText
                            value="raLastMovement-type"
                            format="uppercase"
                        />
                    </OKTableCell>
                    <OKTableCell
                        className={'ra-last-movement__header-row-description'}
                        asHeader={true}
                    >
                        <FormattedText
                            value="raLastMovement-description"
                            format="uppercase"
                        />
                    </OKTableCell>
                    <OKTableCell
                        className={'ra-last-movement__header-row-amount'}
                        asHeader={true}
                    >
                        <FormattedText
                            value="raLastMovement-amount"
                            format="uppercase"
                        />
                    </OKTableCell>
                </OKTableRow>
            </thead>
        );
    }

    handleTypeModalChange(evt) {
        this.setState({
            typeModalValue: evt.value,
        });
    }

    buildModalCustom() {
        const {
            changeLastMovementFilter,
            immLastMovement,
            portfolioModalOptions,
            requestLastMovement,
            setFilter,
        } = this.props;
        const { filterIsOpen, profileId, typeModalValue } = this.state;
        const modal = (
            <RALastMovementFilter
                onTypeModalChange={this.handleTypeModalChange}
                portfolioModalOptions={portfolioModalOptions}
                typeModalValue={typeModalValue}
                immLastMovement={immLastMovement}
                setFilter={setFilter}
                filterIsOpen={filterIsOpen}
                onToggleModal={this.handleToggleModal}
                profileId={profileId}
                changeLastMovementFilter={changeLastMovementFilter}
                requestLastMovement={requestLastMovement}
            />
        );
        return modal;
    }

    buildTableGroupRows(immRowsContentByDate, labelMovementsWithoutDate) {
        return immRowsContentByDate.entrySeq().map((entry, index) => {
            const key = entry[0] || '';
            const items = entry[1];
            if (items.size === 0) {
                return null;
            }
            const formatDate = `${DATE_FORMAT_DAY_MONTH_SHORT}`;
            const rows = this.buildItemsRow(items, formatDate);
            const headerTableDivider =
                key !== LAST_MOVEMENTS_TABLE_RECENT_ITEMS &&
                key !== labelMovementsWithoutDate ? (
                    <OKTableRow className="ra-last-movement__heading">
                        <OKTableCell
                            colSpan={4}
                            className="ra-last-movement__heading-months"
                        >
                            {key}
                        </OKTableCell>
                    </OKTableRow>
                ) : null;

            return (
                <tbody key={index}>
                    {headerTableDivider}
                    {rows}
                </tbody>
            );
        });
    }

    buildTableFullBody(
        rowsContentCurrentYearAndOldOnes,
        labelMovementsWithoutDate,
    ) {
        return rowsContentCurrentYearAndOldOnes.map(immGroupOfDates => {
            return this.buildTableGroupRows(
                immGroupOfDates,
                labelMovementsWithoutDate,
            );
        });
    }

    buildTooltipContent(cgdNumber) {
        return (
            <div>
                <span>{cgdNumber}</span>
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={() => this.handleCopyIbanToClipBoard(cgdNumber)}
                ></button>
            </div>
        );
    }

    buildEmptyState() {
        const { filter } = this.props;
        const typeModalValue = filter.get('typeModalValue');
        const immFilterDate = filter.get('date');
        const message =
            typeModalValue !== RA_MOVEMENTS_FILTER_ALL ||
            immFilterDate.get('isActive') === true
                ? 'raLastMovement-emptyDescriptionWithFilter'
                : 'raLastMovement-emptyDescription';

        return (
            <div className="ra-last-movement__empty-container">
                <img className="ra-last-movement__empty-icon" src={emptyIcon} />
                <div className="ra-last-movement__empty-text">
                    <FormattedText value={message} />
                </div>
            </div>
        );
    }

    handleMoreMovements() {
        recordLink(PROC_RA_LAST_MOVEMENTS, PROC_RA_LAST_MOVEMENTS_SHOW_MORE);
        this.setState({
            rowsNumber: this.state.rowsNumber + 20,
        });
    }

    buildFullFooter() {
        const isHide =
            this.props.rowsContent.slice(0, this.state.rowsNumber).size !==
            this.state.rowsNumber;
        return (
            !isHide && (
                <section className="ra-last-movement__footer-button">
                    <OKButton
                        modifier="link-complementary"
                        onClick={this.handleMoreMovements}
                    >
                        <FormattedText value="raLastMovements-moreMovements" />
                    </OKButton>
                </section>
            )
        );
    }

    buildItemsRow(item, formatDate) {
        const { immProfile } = this.props;
        const originCountry = immProfile.get('originCountry');
        return item.map((items, i) => {
            const formattedAmount = {
                amount: items.get('amount'),
                currency: items.get('currency'),
            };
            const portfolioName = items.get('portfolioName');
            const actualCgdNumber = items.get('cgdIban');
            const tooltipContent = this.buildTooltipContent(actualCgdNumber);
            const shortCgdNumber = getLastNChars(actualCgdNumber, 4, '.');
            const target = <span>{shortCgdNumber}</span>;
            const descriptionLabel = (
                <div>
                    <span>{portfolioName}</span>
                    <FormattedText
                        className="ra-last-movement__cgd-text"
                        value="raLastMovement-raLastMovement_cgdAccountNo"
                    />
                    <span className="ra-last-movement__tooltip">
                        <OKTooltip
                            content={tooltipContent}
                            offset={[10, 10]}
                            placement="bottom"
                            target={target}
                        />
                    </span>
                </div>
            );
            const associatedStrategyLabel = (
                <div className="ra-last-movement__body-associated-strategy">
                    <FormattedText value="raLastMovement-raLastMovement_associatedStrategy" />
                    <span>{items.get('strategy')}</span>
                </div>
            );

            const movementStatus = items.get('status') || STATUS_PENDING;
            const defaultMovementStatusDescription = formatText(
                'raLastMovements-pending',
            ).toUpperCase();
            const movementStatusDescription =
                items.get('statusDescription') ||
                defaultMovementStatusDescription;
            const movementStatusClasses = `ra-last-movement__body-type-status ra-last-movement__body-type-status--${movementStatus.toLowerCase()}`;

            formatDate = DateHelper.isCurrentYear(items.get('bookingDate'))
                ? formatDate
                : DATE_FORMAT_DAY_MONTH_SHORT;
            const dateItem = items.get('bookingDate')
                ? DateHelper.customNormalFormat(
                      items.get('bookingDate'),
                      `${formatDate}`,
                      originCountry,
                  )
                : '-';
            return (
                <OKTableRow key={i} className="ra-last-movement__body">
                    <OKTableCell className="ra-last-movement__body-date">
                        {toCamelCase(dateItem)}
                    </OKTableCell>
                    <OKTableCell className="ra-last-movement__body-type">
                        <tr>
                            <td className="ra-last-movement__body-type-text">
                                {items.get('type')}
                            </td>
                        </tr>
                        <tr>
                            <td className={movementStatusClasses}>
                                {movementStatusDescription}
                            </td>
                        </tr>
                    </OKTableCell>
                    <OKTableCell className="ra-last-movement__body-description">
                        <tr>
                            <td className="ra-last-movement__body-description-text">
                                {descriptionLabel}
                            </td>
                        </tr>
                        <tr>
                            <td>{associatedStrategyLabel}</td>
                        </tr>
                        <tr>
                            <td>{items.get('description')}</td>
                        </tr>
                    </OKTableCell>
                    <OKTableCell className="ra-last-movement__body-amount">
                        <RAOneLineSymbolAmount amountObject={formattedAmount} />
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    buildFilterSelected() {
        const { filter } = this.props;
        const typeModalValue = filter.get('typeModalValue');
        const immFilterDate = filter.get('date');
        let portfolioDateLabel;
        let typeFilterLabel;
        if (
            immFilterDate.get('isActive') &&
            immFilterDate.get('from') &&
            immFilterDate.get('to')
        ) {
            const selectedRange = immFilterDate.get('selected');
            let fromField, toField;
            fromField = formatText(`filterDate-label${selectedRange}`);

            if (selectedRange == 'Custom') {
                fromField = moment(immFilterDate.get('from')).format(
                    'DD-MM-YYYY',
                );
                toField = moment(immFilterDate.get('to')).format('DD-MM-YYYY');
            }

            portfolioDateLabel = (
                <LabelFilterRange
                    from={fromField}
                    to={toField}
                    closeCallback={() => {
                        this.handleCloseFilter('DateValue');
                    }}
                />
            );
        }

        if (typeModalValue !== RA_MOVEMENTS_FILTER_ALL) {
            const labelText = formatText(
                `raLastMovement-raLastMovement_${typeModalValue}`,
            );
            typeFilterLabel = (
                <LabelFilterRange
                    from={labelText}
                    closeCallback={() => {
                        this.handleCloseFilter('typeModalValue');
                    }}
                />
            );
        }

        return (
            <div className="ra-last-movement__filter-name">
                {portfolioDateLabel}
                {typeFilterLabel}
            </div>
        );
    }

    render() {
        const labelMovementsWithoutDate = formatText(
            'myMoneyTransactions-withoutDate',
        );
        const { fullView, isFetching, rowsContent } = this.props;
        let isEmpty = rowsContent.size === 0;
        const tableHeader = this.buildTableHeader(isEmpty, fullView);
        const maxRowsContent = rowsContent.slice(0, this.state.rowsNumber);
        const {
            immCurrentMonthItems,
            immCurrentYearItems,
            immRecentItems,
            immOldYearItems,
            immItemsWithoutDate,
        } = classifyItemsByDate(maxRowsContent, 'bookingDate', true);
        const immRecentItemsMap = Immutable.Map().set(
            LAST_MOVEMENTS_TABLE_RECENT_ITEMS,
            immRecentItems,
        );
        const rowsContentCurrentYearAndOldOnes = [
            immItemsWithoutDate,
            immRecentItemsMap,
            immCurrentMonthItems,
            immCurrentYearItems,
            immOldYearItems,
        ];
        const tableBody =
            !isFetching && !isEmpty
                ? this.buildTableFullBody(
                      rowsContentCurrentYearAndOldOnes,
                      labelMovementsWithoutDate,
                  )
                : null;
        const emptyState =
            !isFetching && isEmpty ? this.buildEmptyState() : null;
        const footer = !isFetching && !isEmpty ? this.buildFullFooter() : null;
        const modalFilter = this.state.filterIsOpen
            ? this.buildModalCustom()
            : null;
        let filterSelected = this.buildFilterSelected();

        let loadingIcon;

        if (isFetching) {
            loadingIcon = (
                <ContentBox>
                    <LoadingSection />
                </ContentBox>
            );
        }
        const filterButton = (
            <div className="ra-last-movement__header-filter">
                <OKButton
                    id="btnFilterLastMovements"
                    modifier="task"
                    onClick={this.handleToggleModal}
                    disabled={isFetching}
                >
                    <i className="icon-filtrar" />
                </OKButton>
            </div>
        );
        const filterIconWithTooltip = (
            <OKTooltip
                content={formatText('filters-filterTooltip').toUpperCase()}
                offset={[0, -15]}
                target={filterButton}
                type="descriptive"
            />
        );
        return (
            <div className="ra-last-movement">
                <div className="ra-last-movement__filter">
                    {filterIconWithTooltip}
                    {filterSelected}
                    <div className="ra-last-movement__header-modal">
                        {modalFilter}
                    </div>
                </div>
                <div className="ra-last-movement__table">
                    <OKTable>
                        {tableHeader}
                        {tableBody}
                    </OKTable>
                </div>
                <div className="ra-last-movement__loading">{loadingIcon}</div>
                <div className="ra-last-movement__empty">{emptyState}</div>
                <div className="ra-last-movement__footer">{footer}</div>
            </div>
        );
    }
}

RALastMovement.propTypes = {
    changeLastMovementFilter: PropTypes.func,
    filter: PropTypes.string,
    fullView: PropTypes.bool,
    isFetching: PropTypes.bool.isRequired,
    immLastMovement: PropTypes.object.isRequired,
    portfolioModalOptions: PropTypes.array,
    profileObject: PropTypes.object.isRequired,
    rowsContent: PropTypes.any,
    requestLastMovement: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    immProfile: PropTypes.object.isRequired,
};

RALastMovement.defaultProps = {
    fullView: false,
};

module.exports = RALastMovement;
